export default "/images/caf32b1f1114c140eab56786de45b52f.avif";